import { configureStore } from '@reduxjs/toolkit';
import storage from 'redux-persist/lib/storage';
import { createMigrate, persistReducer, persistStore } from 'redux-persist';
import { setupListeners } from '@reduxjs/toolkit/query';
import { api } from '@/api/core';
import {
  activeUsersReducer,
  casesListReducer,
  chatHistoryListReducer,
  chatHistoryPersistMigrations,
  CHAT_HISTORY_PERSIST_VERSION,
  toolkitReducer,
  userAboutReducer,
  userManagementReducer,
  chatReducer,
  projectsListReducer,
} from './slices';
import { chatListenerMiddleware } from './middleware/chatListener';

const chatHistoryPersistConfig = {
  key: 'chatHistory',
  storage,
  version: CHAT_HISTORY_PERSIST_VERSION,
  migrate: createMigrate(chatHistoryPersistMigrations),
  whitelist: [
    'allChatHistoryList',
    'chatHistoryList',
    'chatHistoryListRowCount',
    'chatHistoryListPagination',
    'chatHistoryListSorting',
    'chatHistoryListFilters',
  ],
};

const persistedChatHistoryReducer = persistReducer(chatHistoryPersistConfig, chatHistoryListReducer);

export const store = configureStore({
  reducer: {
    [api.reducerPath]: api.reducer,
    activeUsers: activeUsersReducer,
    cases: casesListReducer,
    projects: projectsListReducer,
    chatHistory: persistedChatHistoryReducer,
    toolkit: toolkitReducer,
    userAbout: userAboutReducer,
    userManagement: userManagementReducer,
    chat: chatReducer,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: false,
    })
      .prepend(chatListenerMiddleware.middleware)
      .concat(api.middleware),
});

export const persistor = persistStore(store);

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;

/** Enables `refetchOnFocus` and `refetchOnReconnect`. */
setupListeners(store.dispatch);
